<db-dialog-wrapper [dialog]="this" [width]="'700px'" [noBorder]="true">
  <div class="db-migration-progress-dialog__wrapper"
       *ngIf="!(awsUploadService.uploadFailed|async);else fail">
    <div class="db-migration-progress-dialog__title">
      Uploading your website’s backup ZIP file
    </div>
    <div class="db-migration-progress-dialog__subtitle">
      The time required will depend on the size of the file.
    </div>
    <div class="db-migration-progress-dialog__progress">
      <span class="uploading">Uploading {{awsUploadService.uploadProgress|async}}%</span>
      <span
        [innerHTML]="((awsUploadService.uploadedBytes|async)| size) + ' of ' + ((awsUploadService.totalBytes|async)| size)"></span>
    </div>
    <div class="db-page-loading-bar">
      <db-loading-bar [loading]="true"
                      [height]="4"
                      [progressPercent]="awsUploadService.uploadProgress|async"></db-loading-bar>
    </div>

    <div class="ds-notification-info mt32">
      <div>
        <p>
          <span [innerHTML]="'Please don’t reload this page until the upload has finished.'"></span>
        </p>
      </div>
    </div>
  </div>
  <ng-template #fail>
    <div class="db-migration-progress-dialog__wrapper">
      <div class="db-migration-progress-dialog__title">
        Something went wrong
      </div>
      <div class="db-migration-progress-dialog__subtitle">
        Unfortunately, the upload process was interrupted for some reason. <br> Please attempt the upload again or <a
        target="_blank" (click)="openChat()"><span>contact us</span></a>.
      </div>
      <div class="mt32 db-migration-progress-dialog__try-again">
        <button class="ds-btn-white-gray-border white-bg ds-btn-s m short" (click)="retry()">
          {{'text_uploadTryAgain'|dbText}}
        </button>
      </div>
    </div>
  </ng-template>
</db-dialog-wrapper>
